import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/usuarios/editar/$id")({
  component: Outlet,
  params: {
    parse: ({ id }) => ({ id: Number(id) })
  }
});
